export default __webpack_public_path__ + "static/media/p_3.b421a7d2.jpg";